// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export var StoreTransactionType = /*#__PURE__*/ function(StoreTransactionType) {
    StoreTransactionType[StoreTransactionType["BoughtFromPackPresale"] = 0] = "BoughtFromPackPresale";
    StoreTransactionType[StoreTransactionType["GiftFromAdmin"] = 1] = "GiftFromAdmin";
    StoreTransactionType[StoreTransactionType["DeletedByManager"] = 2] = "DeletedByManager";
    StoreTransactionType[StoreTransactionType["PurchasedCoinFromStripe"] = 3] = "PurchasedCoinFromStripe";
    StoreTransactionType[StoreTransactionType["RefundedCoinToStripe"] = 4] = "RefundedCoinToStripe";
    StoreTransactionType[StoreTransactionType["PurchasedItemFromStore"] = 5] = "PurchasedItemFromStore";
    StoreTransactionType[StoreTransactionType["RefundedItemToStore"] = 6] = "RefundedItemToStore";
    StoreTransactionType[StoreTransactionType["EarnedFromAchievement"] = 7] = "EarnedFromAchievement";
    StoreTransactionType[StoreTransactionType["EarnedFromTournament"] = 8] = "EarnedFromTournament";
    StoreTransactionType[StoreTransactionType["PurchasedCoinFromXsolla"] = 9] = "PurchasedCoinFromXsolla";
    StoreTransactionType[StoreTransactionType["RefundedCoinToXsolla"] = 10] = "RefundedCoinToXsolla";
    StoreTransactionType[StoreTransactionType["PurchasedCoinFromDiscordIAP"] = 11] = "PurchasedCoinFromDiscordIAP";
    StoreTransactionType[StoreTransactionType["RefundedCoinToDiscordIAP"] = 12] = "RefundedCoinToDiscordIAP";
    StoreTransactionType[StoreTransactionType["Membership"] = 13] = "Membership";
    StoreTransactionType[StoreTransactionType["GiftedMembership"] = 14] = "GiftedMembership";
    StoreTransactionType[StoreTransactionType["EarnedByGifting"] = 15] = "EarnedByGifting";
    StoreTransactionType[StoreTransactionType["EarnedWithReferralSystem"] = 16] = "EarnedWithReferralSystem";
    StoreTransactionType[StoreTransactionType["EarnedWithReactivationMessage"] = 17] = "EarnedWithReactivationMessage";
    // PurchasedFromOffer,
    StoreTransactionType[StoreTransactionType["PurchasedCoinFromAppleIAP"] = 18] = "PurchasedCoinFromAppleIAP";
    StoreTransactionType[StoreTransactionType["RefundedCoinToAppleIAP"] = 19] = "RefundedCoinToAppleIAP";
    StoreTransactionType[StoreTransactionType["PurchasedCoinFromAndroidIAP"] = 20] = "PurchasedCoinFromAndroidIAP";
    StoreTransactionType[StoreTransactionType["RefundedCoinToAndroidIAP"] = 21] = "RefundedCoinToAndroidIAP";
    return StoreTransactionType;
}({});
export const PURCHASE_STORE_TRANSACTION_TYPES = [
    0,
    3,
    9,
    11,
    13
];
// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export var StoreItemCategory = /*#__PURE__*/ function(StoreItemCategory) {
    StoreItemCategory[StoreItemCategory["PresalePack"] = 0] = "PresalePack";
    StoreItemCategory[StoreItemCategory["Expansion"] = 1] = "Expansion";
    StoreItemCategory[StoreItemCategory["Map"] = 2] = "Map";
    StoreItemCategory[StoreItemCategory["Icon"] = 3] = "Icon";
    StoreItemCategory[StoreItemCategory["Color"] = 4] = "Color";
    StoreItemCategory[StoreItemCategory["Consumable"] = 5] = "Consumable";
    StoreItemCategory[StoreItemCategory["Membership"] = 6] = "Membership";
    return StoreItemCategory;
}({});
// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export var StorePresalePackType = /*#__PURE__*/ function(StorePresalePackType) {
    StorePresalePackType[StorePresalePackType["SettlerPack"] = 0] = "SettlerPack";
    StorePresalePackType[StorePresalePackType["ColonistPack"] = 1] = "ColonistPack";
    StorePresalePackType[StorePresalePackType["FounderPack"] = 2] = "FounderPack";
    return StorePresalePackType;
}({});
// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export var StoreMapType = /*#__PURE__*/ function(StoreMapType) {
    StoreMapType[StoreMapType["Earth"] = 0] = "Earth";
    StoreMapType[StoreMapType["USA"] = 1] = "USA";
    StoreMapType[StoreMapType["UK"] = 2] = "UK";
    StoreMapType[StoreMapType["Diamond"] = 3] = "Diamond";
    StoreMapType[StoreMapType["Gear"] = 4] = "Gear";
    StoreMapType[StoreMapType["Lakes"] = 5] = "Lakes";
    StoreMapType[StoreMapType["Pond"] = 6] = "Pond";
    StoreMapType[StoreMapType["Twirl"] = 7] = "Twirl";
    StoreMapType[StoreMapType["Classic4PRandom"] = 8] = "Classic4PRandom";
    StoreMapType[StoreMapType["ShuffleBoard"] = 9] = "ShuffleBoard";
    StoreMapType[StoreMapType["BlackForest"] = 10] = "BlackForest";
    StoreMapType[StoreMapType["Volcano"] = 11] = "Volcano";
    StoreMapType[StoreMapType["GoldRush"] = 12] = "GoldRush";
    return StoreMapType;
}({});
// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
export var StoreIconType = /*#__PURE__*/ function(StoreIconType) {
    StoreIconType[StoreIconType["FounderHat"] = 0] = "FounderHat";
    StoreIconType[StoreIconType["ColonistHat"] = 1] = "ColonistHat";
    StoreIconType[StoreIconType["SettlerHat"] = 2] = "SettlerHat";
    StoreIconType[StoreIconType["ChristmasHat"] = 3] = "ChristmasHat";
    StoreIconType[StoreIconType["Player"] = 4] = "Player";
    StoreIconType[StoreIconType["PirateShip"] = 5] = "PirateShip";
    StoreIconType[StoreIconType["MedalGold"] = 6] = "MedalGold";
    StoreIconType[StoreIconType["MedalSilver"] = 7] = "MedalSilver";
    StoreIconType[StoreIconType["MedalBronze"] = 8] = "MedalBronze";
    StoreIconType[StoreIconType["Elephant"] = 9] = "Elephant";
    StoreIconType[StoreIconType["Avocado"] = 10] = "Avocado";
    StoreIconType[StoreIconType["Cactus"] = 11] = "Cactus";
    StoreIconType[StoreIconType["Crown"] = 12] = "Crown";
    StoreIconType[StoreIconType["Swords"] = 13] = "Swords";
    StoreIconType[StoreIconType["Helmet"] = 14] = "Helmet";
    StoreIconType[StoreIconType["Snorkel"] = 15] = "Snorkel";
    StoreIconType[StoreIconType["Scarf"] = 16] = "Scarf";
    StoreIconType[StoreIconType["Tie"] = 17] = "Tie";
    StoreIconType[StoreIconType["Worker"] = 18] = "Worker";
    StoreIconType[StoreIconType["Sombrero"] = 19] = "Sombrero";
    StoreIconType[StoreIconType["Farmer"] = 20] = "Farmer";
    StoreIconType[StoreIconType["RobberSanta"] = 21] = "RobberSanta";
    StoreIconType[StoreIconType["RobberLunar"] = 22] = "RobberLunar";
    StoreIconType[StoreIconType["RobberCupid"] = 23] = "RobberCupid";
    StoreIconType[StoreIconType["Mummy"] = 24] = "Mummy";
    StoreIconType[StoreIconType["Gifter"] = 25] = "Gifter";
    return StoreIconType;
}({});
// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export var StorePlayerColor = /*#__PURE__*/ function(StorePlayerColor) {
    StorePlayerColor[StorePlayerColor["Gold"] = 0] = "Gold";
    StorePlayerColor[StorePlayerColor["Silver"] = 1] = "Silver";
    StorePlayerColor[StorePlayerColor["Bronze"] = 2] = "Bronze";
    StorePlayerColor[StorePlayerColor["Black"] = 3] = "Black";
    StorePlayerColor[StorePlayerColor["Purple"] = 4] = "Purple";
    StorePlayerColor[StorePlayerColor["MysticBlue"] = 5] = "MysticBlue";
    StorePlayerColor[StorePlayerColor["White"] = 6] = "White";
    StorePlayerColor[StorePlayerColor["Pink"] = 7] = "Pink";
    return StorePlayerColor;
}({});
export var StoreConsumable = /*#__PURE__*/ function(StoreConsumable) {
    StoreConsumable[StoreConsumable["UsernameChange"] = 0] = "UsernameChange";
    StoreConsumable[StoreConsumable["PurchaseResourceCardWithColonistCoin"] = 1] = "PurchaseResourceCardWithColonistCoin";
    StoreConsumable[StoreConsumable["PurchaseDevelopmentCardWithColonistCoin"] = 2] = "PurchaseDevelopmentCardWithColonistCoin";
    StoreConsumable[StoreConsumable["PremiumRoom"] = 3] = "PremiumRoom";
    return StoreConsumable;
}({})// export enum StoreOfferType {
//     Expansion5678Players,
// }
;
